// vendor
import _clone from 'lodash/clone'

export default {
  methods: {
    combineFormRows (formElements) {
      const elements = _clone(formElements)
      let rows = {}

      for (let i = 0; i < elements.length; i++) {
        let next = elements[i + 1]
        rows[`row${i}`] = []
        rows[`row${i}`].push(elements[i])
        if (elements[i].start_with_new_line === true && next && next.start_with_new_line === false) {
          rows[`row${i}`].push(next)
          i++
        }
      }
      this.hasRowColumns = true
      return rows
    }
  },
  data () {
    return {
      hasRowColumns: false
    }
  }
}
